import { ValidateJSModel, LocationModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';

interface LocationStreetCityCountryModel {
  street: LocationModel['street']
  city: LocationModel['city']
  country: LocationModel['country']
}

const locationStreetCityCountryModelValidator: ValidateJSModel<LocationStreetCityCountryModel> = {
  street: locationModel.street as ValidateJSModelAttribute<
    LocationStreetCityCountryModel,
    'street'
  >,
  city: locationModel.city as ValidateJSModelAttribute<LocationStreetCityCountryModel, 'city'>,
  country: locationModel.country as ValidateJSModelAttribute<
    LocationStreetCityCountryModel,
    'country'
  >,
};

export default locationStreetCityCountryModelValidator;
